import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Info from './pages/Info';
import Rules from './pages/Rules';
import Jobs from './pages/Jobs';
import FAQ from './pages/FAQ';
import Community from './pages/Community';
import Team from './pages/Team';
import Leaderboards from './pages/Leaderboards';
import LoadingScreen from './components/LoadingScreen';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate initial asset loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500); // 2.5 seconds loading time

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <Router>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/info" element={<Info />} />
              <Route path="/rules" element={<Rules />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/community" element={<Community />} />
              <Route path="/team" element={<Team />} />
              <Route path="/leaderboards" element={<Leaderboards />} />
            </Routes>
          </Layout>
        </Router>
      )}
    </>
  );
}

export default App;
